import { formatNumberRu } from '@wit-support/ui';
/**
 * Кратность к обычному ролику аккаунта: «×1,8», «×2», «×12». Меньше ×0,1 —
 * две значащие цифры, иначе провал «×0,04» превратился бы в «×0».
 * `null`/не число — «—».
 */
export function formatMultiple(x) {
    if (x === null || x === undefined || !Number.isFinite(x))
        return '—';
    const digits = x >= 10 ? 0 : x >= 0.1 ? 1 : 2;
    return `×${formatNumberRu(x, { maximumFractionDigits: digits })}`;
}
//# sourceMappingURL=format-multiple.js.map